import {computed, ref} from 'vue'
import type {AllFormValue, FilterItem, Kind, SearchAttributes} from 'src/biz_spa/types'
import {addAttributes} from 'src/biz_spa/modules/filterModalConst'
import {useStore} from 'vuex'

/**
 * @param kinds 必ずユーザーが使いやすい順番で渡すこと
 */
export const useFilterModal = (params: { kinds: Kind[] }) => {
  type FormValue = Pick<AllFormValue, typeof params.kinds[number]>
  const kinds = ref<Kind[]>([])
  const store = useStore()
  const searchAttributes = computed<SearchAttributes>(() => store.state.companiesSearchTagGroups.data)
  const filterFormValues = computed<FormValue>(() => store.state.companiesSearchTagGroups.formValues)
  const filterItems = ref<FilterItem[]>([])

  kinds.value = [...params.kinds]

  const setFormValues = (payload: FormValue): Promise<void> => store.dispatch('companiesSearchTagGroups/setFormValues', payload)
  const formInitialValues = (): FormValue => {
    // いいやり方が思い付かずasを使った
    const obj: FormValue = {} as FormValue
    kinds.value.forEach(kind => obj[kind] = [])
    return obj
  }

  const initFilterItems = () => {
    const sortForUtility = (a :Kind, b: Kind) => kinds.value.indexOf(a) - kinds.value.indexOf(b)
    const attributes = kinds.value
      .sort(sortForUtility)
      .map(kind => searchAttributes.value[kind])
      .filter(kind => kind != null) // オリジナルタグが設定されていないとundefinedが入る
    filterItems.value = attributes.map((attr) => {
      if (attr && attr.kind) {
        return addAttributes(attr, attr.kind)
      }
    })
  }
  const resetFilterModal = () => {
    setFormValues(formInitialValues())
  }

  const removeKind = (target: Kind) => {
    kinds.value = kinds.value.filter((kind) => kind !== target)
    resetFilterModal()
    initFilterItems()
  }

  // TODO:型パズルいい感じにしたい
  type ToggleFormValueArgs =
    | {kind: Extract<keyof FormValue, 'stores' | 'locales' | 'search_keyword_label_brandeds' | 'search_keyword_label_selecteds'>, id: string}
    | {kind: Exclude<keyof FormValue, 'stores' | 'locales' | 'search_keyword_label_brandeds' | 'search_keyword_label_selecteds'>, id: number}
  const toggleFormValue = ({kind, id}: ToggleFormValueArgs): void => {
    const newFormValues: FormValue = Object.assign({}, filterFormValues.value)

    if (kind === 'stores' || kind === 'locales' || kind === 'search_keyword_label_brandeds' || kind === 'search_keyword_label_selecteds') {
      if (newFormValues[kind].includes(id)) {
        newFormValues[kind] = newFormValues[kind].filter((_id) => {
          return _id !== id
        })
      } else {
        newFormValues[kind].push(id)
      }
    } else {
      if (newFormValues[kind].includes(id as number)) {
        newFormValues[kind] = newFormValues[kind].filter((_id) => {
          return _id !== id
        })
      } else {
        newFormValues[kind].push(id as number)
      }
    }
    setFormValues(newFormValues)
  }

  return {
    filterItems,
    searchAttributes,
    filterFormValues,
    initFilterItems,
    resetFilterModal,
    toggleFormValue,
    setFormValues,
    removeKind,
  }
}
